import store from '@/store'
export default [
  {
    path: '/beginning-balances',
    name: 'beginning-balance',
    meta: { requiresAuth: true },
    component: () => import('@/pages/beginning-balance/index.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('beginningBalance/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/beginning-balances/:id',
    name: 'beginning-balance-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/beginning-balance/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('beginningBalance/dataBeforeCreate')
      let response = await store.dispatch('beginningBalance/find', to.params.id)
      let { ...resource } = response.data
      to.params.editData = resource
      next()
    }
  }
]
